export default __webpack_public_path__ + "static/media/NIAS0600.34I-42726_-25533_0.62baec45.jpg";